import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import Api, { BaseUrl } from "../../../../api/Api";
import LoadingStuck from "../../../reuse/LoadingStuck";

const ModalCreateFacility = () => {
    const [show, setShow] = useState(false);
    
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const send_data = async(data) => {
        try {
            const response = await Api({
                method:"post",
                url:`/facilities/add`,
                headers:{},
                data:data
            })
            alert("Предприятие создано.");
            window.location.reload();
        } catch (error) {
            // alert("Ошибка при создании предприятия")
            alert(`Ошибка при создании предприятия. \n ${error}`);
        }
    }

    const handleSave = async(e) =>{
        e.preventDefault();
        const data = {
            short_name:document.getElementById("short_name").value,
            full_name:document.getElementById("full_name").value,
            description:document.getElementById("description").value
        }
        await send_data(data);
    }

    return(
        <>
        <Button className="custom-btn m-1" onClick={handleShow}>
            Создать
        </Button>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title className="text_font">Создать предприятие</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave}>
                    <Form.Control 
                        id="short_name"
                        placeholder="Сокращение..." 
                        className="mb-1"
                        required
                        />
                    <Form.Control 
                        id="full_name"
                        placeholder="Полное название..." 
                        className="mb-1"
                        required/>
                    <Form.Control 
                        id="description"
                        as="textarea" 
                        rows={3}
                        placeholder="Описание..." 
                        className="mb-1"/>
                    <div className="mt-1">
                        <Button 
                        type="submit"
                        variant="primary" 
                        className="free-btn">
                            Создать
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
        </>
    )
}

const FacilityCard = ({data}) =>{
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const deleteFacility = async(id_facility) => {
        try {
            const result = await Api({
                method:"delete",
                url:`/facilities/@${id_facility}`,
                headers:{}
            })
            alert("Предприятие удалено.");
            window.location.reload();
        } catch (error) {
            // alert("Ошибка при удалении предприятия.")
            alert(`Ошибка при удалении предприятия. \n ${error}`);
        }
    }

    const handleDelete = async() =>{
        let warning =window.confirm("Внимание! Вы уверены, что хотите удалить предприятие? После удаления, его невозможно будет восстановить!")
        if(warning){
            await deleteFacility(data.id);
        }
    }

    return(<>
        <Card className="m-1" onClick={handleShow}>
            <Card.Body>
                <div className="text_font">
                    <div >Сокращение: {data.short_name || ""}</div>
                    <div className="audit_card_block_text">Полное название: {data.full_name || ""}</div>
                </div>
            </Card.Body>
        </Card>

        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text_font">Информация о предприятии</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Control
                className="mb-1" 
                value={data.short_name || ""}
                placeholder="Сокращение..."
                readOnly
                disabled/>
                <Form.Control 
                className="mb-1" 
                placeholder="Полное название..."
                readOnly
                disabled
                value={data.full_name || ""}/>
                <Form.Control
                as="textarea"
                className="mb-1" 
                placeholder="Описание..."
                readOnly
                disabled
                value={data.description || ""}/>
            </Form>
            <div className="mt-2">
                <Row>
                <Col ></Col>
                <Col>
                    <Button variant="danger" className="free-btn" onClick={()=>handleDelete()}>
                        Удалить
                    </Button>
                </Col>
            </Row>
            </div>
        </Modal.Body>
      </Modal>
    </>)
}

const AdminFacilityBlockInterface = ({data}) => {
    const [facilityData,setFacilityData]=useState(data);
    const filters_facility_options=data.map((facility)=>{return {value:facility.id, label:`(${facility.short_name || ""}) ${facility.full_name || ""}`}})
    const [filterValue,setFilterValue]=useState("");

     const handleChange = (selected) => {
        setFilterValue(selected);
        // console.log('Выбрано:', selected);
        if(selected==null){
            setFacilityData(data)
        }else{
            const new_data=data.filter(item => item.id === selected.value);
            setFacilityData(new_data);
        }
    };
    return(
        <>
        <div className="search_filters_admin_block">
            <ModalCreateFacility/>
            <Select 
            className="m-1 search_filter_field" 
            options={filters_facility_options} 
            value={filterValue}
            onChange={handleChange}
            placeholder="поиск по предприятиям..." 
            isClearable/>
            {/* <Button className="custom-btn m-1">Поиск</Button> */}
        </div>
        <div>
            {facilityData.length==0 ? <p>Нет предприятий</p> : 
            <>
            <Row className="mt-1">
                {facilityData.map((facility)=>(
                    <Col key={facility.username} md={4} className="mb-1">
                        <FacilityCard data={facility}/>
                    </Col>))}</Row></> }
        </div>
        </>
    )
}

const AdminFacilityFetch = () => {
    const [loading,setLoading]=useState(false);
    const [error, setError]=useState(false);
    const [block, setBlock]=useState(false);

    const [data,setData]=useState(null);
    const [errorInfo,setErrorInfo]=useState(null);

    const getFacilities = async() => {
        try {
            const response = await Api({
                method:"get",
                url:`/facilities/`,
                headers:{} 
            })
            setBlock(true);
            setData(response.data)
        } catch (error) {
            // setErrorInfo("Ошибка при подгрузке данных о заводах");
            setErrorInfo(error);
            setError(true);
        }
    }

    useEffect(()=>{
        const setup = async() =>{
            setLoading(true);
            await getFacilities();
            setLoading(false);
        }
        setup();
    },[])


    if(loading){return(<LoadingStuck/>)}
    if(error){return(<><p className="warning_text sepatate_text">{errorInfo}</p></>)}
    if(block){return(<AdminFacilityBlockInterface data={data}/>)}
    // if(block){return(<><p>{JSON.stringify(data)}</p></>)}
}

const AdminFacilityBlock = () =>{
    return(<AdminFacilityFetch/>)
}
export default AdminFacilityBlock;